import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, []);
  const sendInvoice = `sendInvoice(input: ${dataCreate})`;
  return gql`
  mutation {
    ${sendInvoice} {
      id
    }
  }
`;
};
